import { Link, usePathname } from '@/i18n/navigation';
import { useTranslations } from 'next-intl';
import {
    NAVIGATION_ACTIVE_ITEM_CLASS,
    NAVIGATION_ITEM_CLASS,
    NAVIGATION_LAST_ITEM_CLASS,
    NavigationDropDown,
} from './navigation-dropdown';

type Props = {
    isActive?: boolean;
    onLinkClickAction?: () => void;
};

export const GuestDropDown = ({ isActive, onLinkClickAction }: Props) => {
    const t = useTranslations('Navigation');
    const pathname = usePathname();
    const handleLinkClick = (close: () => void) => {
        close();
        onLinkClickAction?.();
    };

    return (
        <NavigationDropDown label={t('guest.label')} isActive={isActive}>
            {(close) => (
                <>
                    <li>
                        <Link
                            className={
                                pathname.includes('/tv-rights-buyers')
                                    ? NAVIGATION_ACTIVE_ITEM_CLASS
                                    : NAVIGATION_ITEM_CLASS
                            }
                            href="/tv-rights-buyers"
                            onClick={() => handleLinkClick(close)}
                        >
                            {t('guest.buyer')}
                        </Link>
                    </li>
                    <li>
                        <Link
                            className={`${pathname.includes('/tv-rights-sellers') ? NAVIGATION_ACTIVE_ITEM_CLASS : NAVIGATION_ITEM_CLASS} ${NAVIGATION_LAST_ITEM_CLASS}`}
                            href="/tv-rights-sellers"
                            onClick={() => handleLinkClick(close)}
                        >
                            {t('guest.seller')}
                        </Link>
                    </li>
                </>
            )}
        </NavigationDropDown>
    );
};
